import React, { useState } from "react";
import { T } from "../theme";
import { Btn, Card, SectionTitle } from "../ui";

const FAQS = [
  {
    q: "How do I add a tape to my collection?",
    a: "Tap the + button in the bottom nav (or \"Add a Tape\" on Home), fill in the details, and optionally attach a photo. Higher tiers allow more photos per tape.",
  },
  {
    q: "How does buying or trading tapes work?",
    a: "Open a tape you own and tap \"List for Sale / Trade.\" Other collectors can browse it under Shop → Tapes and reach out using the contact info in your description — there's no in-app payment or messaging yet, so buyers and sellers arrange payment and shipping directly.",
  },
  {
    q: "What is the seller rating for?",
    a: "Once you mark a listing Sold, anyone who views it (other than you) can leave you a star rating. It's honor-system, tied to that specific completed listing, and averages into the rating shown next to your name on future listings.",
  },
  {
    q: "What do the membership tiers include?",
    a: "Stereo 8 (free) covers the basics. Quad-8 and Vault Reserve raise your tape/photo/listing limits and add CSV/PDF export and wishlist match alerts. Vault Supreme is a separate add-on for the player marketplace and repair directory. Details and pricing are on your Profile tab.",
  },
  {
    q: "How does the Merch tab work?",
    a: "Merch is powered by our Shopify store. Browsing and your cart happen right in the app; tapping Checkout hands you off to Shopify's own secure checkout page to complete payment.",
  },
  {
    q: "I forgot my password — what do I do?",
    a: "On the login screen, tap \"Forgot Password\" and enter your email. You'll get a reset link right away — no need to wait until you're near anything you've written the password down on.",
  },
  {
    q: "Are my values professional appraisals?",
    a: "No — estimated values and gain/loss figures are whatever you enter yourself, meant for tracking your own collection, not formal appraisals.",
  },
];

function FaqRow({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.border}`, padding: "12px 0" }}>
      <div onClick={() => setOpen((o) => !o)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
        <span style={{ fontSize: 13, color: T.text, fontWeight: "bold", paddingRight: 10 }}>{q}</span>
        <span style={{ color: T.accent, fontSize: 14 }}>{open ? "−" : "+"}</span>
      </div>
      {open && <div style={{ fontSize: 12.5, color: T.muted, lineHeight: 1.6, marginTop: 8 }}>{a}</div>}
    </div>
  );
}

export default function HelpScreen({ onBack }) {
  return (
    <div>
      <SectionTitle>Frequently Asked</SectionTitle>
      <Card>
        {FAQS.map((f, i) => <FaqRow key={i} {...f} />)}
      </Card>

      <div style={{ textAlign: "center", marginTop: 18 }}>
        <div style={{ fontSize: 11, color: T.muted, marginBottom: 4 }}>Still stuck?</div>
        <a href="mailto:suttonimpressions.js@gmail.com" style={{ fontSize: 11, color: T.muted, textDecoration: "underline" }}>
          Email support
        </a>
      </div>

      <Btn variant="outline" onClick={onBack} style={{ width: "100%", marginTop: 20 }}>← Back</Btn>
      <div style={{ height: 20 }} />
    </div>
  );
}
